import { useCallback } from 'react';
import { debounce } from 'lodash';

const useDebouncedFilterSearch = (onFilter, searchByKey, delay = 500) => {
  const onSearch = useCallback(
    value => {
      onFilter(prev => ({
        ...prev,
        start: 0,
        isNextPage: false,
        searchBy: { [searchByKey]: value },
      }));
    },
    [onFilter, searchByKey]
  );

  return useCallback(debounce(onSearch, delay), [onSearch, delay]);
};

export default useDebouncedFilterSearch;
